import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Moment} from "moment";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";


interface Range {
  from: any,
  to: any
}

interface Event {
  id: string,
  index: string,
  eventRef: any,
  title: string,
  start: Moment,
  end: Moment,
  color: any,
  textColor?: string
}

export class PlanningProjectsCalendarViewCtrl implements IController {

  planningProjectViewCtrl: IController;
  projects: any;
  from: Moment;
  to: Moment;
  onRangeChange: Function;
  onDeleteProject: Function;

  public selectedProjects: any[];
  public selectedRange: Range;
  public views: string[];
  public timeZone: any;
  public events: any;

  private projectStatusColorMap: any;
  private expendedProject: any;
  public eventLimit: any;
  public selectedView: any;
  public calendarHeight: any;

  /* @ngInject */
  constructor(private splitService, private planningConstants, private IAMPermissions: IAMPermissionsService,
              private confirmDialogService: ConfirmDialogService, private commonsDialogService: CommonsDialogService,
              private planningDraftsService: PlanningDraftsService, private planningDialogService: PlanningDialogService,
              private $log, private $state, private moment, private commonsService: CommonsService, private $window) {

    this.projectStatusColorMap = planningConstants.projectStatusColorMap;
    this.timeZone = splitService.getTimeZone();
    this.events = this.convertProjectsToEvents(this.projects);
  }

  $onInit() {

    this.selectedProjects = [];
    this.expendedProject = undefined;
    this.selectedRange = {from: undefined, to: undefined};

    this.views = ['basicWeek', 'month'];
    this.eventLimit = 7;
    this.selectedView = 'basicWeek';
    this.events = this.convertProjectsToEvents(this.projects);


    if (this.from && this.to) {
      this.selectedRange = {
        from: this.moment(this.from).startOf('day').valueOf(),
        to: this.moment(this.to).endOf('day').valueOf()
      };
      this.reSetSelectedProjects(this.events, this.selectedRange.from, this.selectedRange.to);
    }
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.projects && !onChangesObj.projects.isFirstChange()) {
      this.events = this.convertProjectsToEvents(this.projects);
      this.reSetSelectedProjects(this.events, this.selectedRange.from, this.selectedRange.to);
    }
    if ((onChangesObj.from && !onChangesObj.from.isFirstChange()) ||
      (onChangesObj.to && !onChangesObj.to.isFirstChange())) {
      this.selectedProjects = [];
      this.expendedProject = undefined;
      this.selectedRange = {
        from: this.moment(this.from).startOf('day').valueOf(),
        to: this.moment(this.to).endOf('day').valueOf()
      }
    }
  }

  // ******************************
  //        Public methods
  // ******************************
  getHeight(): number {
    const element = angular.element(document.querySelector('#calendar-container'));
    return element[0].clientHeight;
  }

  onEventClick(project, $event) {
    const actions = ['Enter', 'Open in new tab', 'Delete'];

    this.commonsService.openActionPanel(actions, $event)
      .then((reason) => {
        if (reason === 'Enter') {
          this.goToProject(project);
        }
        if (reason === 'Open in new tab') {
          const url = this.getProjectUrl(project);
          this.$window.open(url, '_blank');
        }
        if (reason === 'Delete') {
          this.onDeleteProject({project: project, $event: $event});
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });

  }

  private goToProject(project) {
    if (_.get(project, 'eventRef.status') === 'DISPATCHED') {
      this.$state.go(this.planningConstants.states.completed, {
        projectId: project.id,
        draftId: project.eventRef.selectedDraftId
      }, {notify: true, reload: false});
    } else if (_.get(project, 'eventRef.selectedDraftId')) {
      this.$state.go(this.planningConstants.states.draft, {
        projectId: project.id,
        draftId: project.eventRef.selectedDraftId
      }, {notify: true, reload: false});
    } else {
      this.$state.go(this.planningConstants.states.project, {
        projectId: project.id,
        draftId: undefined
      }, {notify: true, reload: false});
    }
  }

  private getProjectUrl(project) {
    if (_.get(project, 'eventRef.status') === 'DISPATCHED') {
      return this.$state.href(this.planningConstants.states.completed, {
        projectId: project.id,
        draftId: project.eventRef.selectedDraftId
      });
    } else if (_.get(project, 'eventRef.selectedDraftId')) {
      return this.$state.href(this.planningConstants.states.draft, {
        projectId: project.id,
        draftId: project.eventRef.selectedDraftId
      });
    } else {
      return this.$state.href(this.planningConstants.states.project, {
        projectId: project.id,
        draftId: undefined
      });
    }
  }

  onSelectProject(project) {
    this.planningDraftsService.getDraft(project.selectedDraftId, project.id)
      .then((draft) => {
        this.planningDialogService.draftOverview(draft);
      })
      .catch((error) => {
        this.$log.info('Failed to get draft', error);
      })
  }

  setSelectedProjectsAndRange(from, to, events) {
    this.expendedProject = undefined;
    this.selectedProjects = _.map(events, function (e) {
      return e.eventRef;
    });
    this.selectedRange = {
      from: from,
      to: to
    };
  }


//       function onEventChange(event, delta) {
//          // var shiftCopy = angular.copy(event.eventRef);
//       }
  onDayDoubleClick(date, $event) {
    const from: Moment = date.startOf('day').valueOf();
    const to: Moment = date.endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).valueOf();

    this.planningProjectViewCtrl.onSendToPlanning($event, from, to);
  }

  onViewRender(start: Moment, end: Moment, view) {
    this.selectedView = view.name;

    if (view.name === 'month') {
      this.eventLimit = 3;
    } else if (view.name === 'basicWeek') {
      this.eventLimit = 7;
    }

    // On Init Display Today's Selected Projects.
    if (!this.from && !this.to) {
      const from = this.moment(start).startOf('day').valueOf();
      const to = this.moment(end).valueOf();
      this.onRangeChange({from: from, to: to});
    } else {

      const hasFromChanged = this.moment(this.moment(this.from).format("MM/DD/YYYY")).isSame(this.moment(start).format("MM/DD/YYYY"));
      const hasToChanged = this.moment(this.moment(this.to).format("MM/DD/YYYY")).isSame(this.moment(end).format("MM/DD/YYYY"));

      if (!hasFromChanged || !hasToChanged) {
        this.onRangeChange({from: start.valueOf(), to: end.valueOf()});
      }

    }
  }

  // ******************************
  //        Private methods
  // ******************************

  private convertProjectsToEvents(projects): Event[] {
    return _.map(projects, (p, index): Event => {
      return {
        id: p.id,
        index: index,
        eventRef: p,
        title: p.name,
        start: this.moment(p.from),
        end: this.moment(p.to),
        color: this.projectStatusColorMap[p.status],
        textColor: 'black'
      }
    });
  }

  private reSetSelectedProjects(events: Event[], from, to) {
    this.expendedProject = undefined;

    const eventsInRange = this.getEventsInRange(from, to, events);

    this.selectedProjects = _.map(eventsInRange, (e): Event => {
      return e.eventRef;
    });
  }

  private getEventsInRange(from: Moment, to: Moment, events: Event[]) {
    return _.filter(events, (e) => {
      const start = this.moment(e.start);
      const end = this.moment(e.end);

      if (!start.isValid() || !end.isValid()) {
        return false;
      }

      const eventAllDatesInRange: number[] = this.getAllDatesInRange(start, end);

      return _.filter(eventAllDatesInRange, (date: Moment) => {
        return date === this.moment(from).valueOf() ||
          date === this.moment(to).valueOf() ||
          this.moment(date).isBetween(from, to);
      }).length > 0;

    });
  }

  private getAllDatesInRange(start: Moment, end: Moment): number[] {
    const dates: number[] = [];
    const checkDate: Moment = start;

    while (checkDate.isBefore(end) || checkDate.isSame(end)) {
      dates.push(checkDate.valueOf());
      checkDate.add(1, 'days');
    }
    return dates;
  }


}


angular
  .module('bringoz.admin.planning')
  .component(
    'planningProjectsCalendarView', {
      require: {
        planningProjectViewCtrl: '^planningProjectsScheduledView'
      },
      bindings: {
        projects: '<',
        from: '<?',
        to: '<?',
        onRangeChange: '&',
        onDeleteProject: '&'
      },
      template: require('./planning-projects-calendar-view.html').default,
      controller: PlanningProjectsCalendarViewCtrl
    }
  )
;
